



































import DetachableHeader from 'vue-detachable-header'
import 'vue-detachable-header/index.css'
import Logo from 'library/components/globals/logo'
import MobileNav from './mobile-nav'
import UtilityLinks from './utility-links'
import CartTrigger from './cart-trigger'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import HeaderHeightMixin from 'library/mixins/header-height'
import TabbedNav from '../tabbed-nav'
import Banner from '../banner/banner'

export default

	mixins: [ HeaderHeightMixin ]

	components: {
		TabbedNav
		Banner
		DetachableHeader
		Logo
		MobileNav
		UtilityLinks
		CartTrigger
	}

	data: ->
		open: false

	methods:

		# If I'm going back to the main mobile pane,
		# then try to re-establish a scroll lock
		reEstablishScrollLock: ->
			clearAllBodyScrollLocks()
			html = document.querySelector 'html'
			html.style.height = ''

			# ref to this
			scroll = @$refs.scrollable
			scope = @

			# if you're in a deep mobile pane,
			# re-init the body scroll lock
			# checking in case you client-side navigate
			# from a deep pane, in which case we don't want to lock
			@$wait 50, ->
				if scope.open
					disableBodyScroll scroll
					html = document.querySelector 'html'
				html.style.height = '100vh'

	watch:

		# main top level scroll lock decided
		# from the hamburger menu
		open: ->
			if @open
				disableBodyScroll @$refs.scrollable
				html = document.querySelector 'html'
				html.style.height = '100vh'
			else
				clearAllBodyScrollLocks()
				html = document.querySelector 'html'
				html.style.height = ''

		# Close the nav when the route changes
		$route: ->
			@open = false
			@dropdownOpen = false
			clearAllBodyScrollLocks()
			html = document.querySelector 'html'
			html.style.height = ''

